<template>
  <div class="privacyAgreement">
    <div class="privacyAgreement-top">
      <h3>{{ info.title }}</h3>
      <div v-if="info.content" v-html="info.content"></div>
      <div v-else class="agreement-msg">未找到信息</div>
    </div>
  </div>
</template>

<script>
import { privacyPolicy } from "@/api/Login";

export default {
  name: "RegisterAgreement",
  data() {
    return {
      info: {},
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      privacyPolicy(49).then((res) => {
        this.info = res.data;
      });
    },
  },
};
</script>

<style lang="scss">
.privacyAgreement {
  .privacyAgreement-top {
    width: 1280px;
    margin: 0 auto;

    h3 {
      margin-top: 30px;
      margin-bottom: 15px;
      font-size: 20px;
    }

    .agreement-msg {
      margin: 50px auto;
      font-size: 30px;
      color: #333333;
    }

    p {
      margin: 0 0 12px;
      line-height: 1.8;
      min-height: 20px;
      text-indent: 2em;
      word-break: break-word;
    }
  }
}
</style>
